import { IComponentOptions } from 'angular';
import { ChoosePlanWizardViewController } from './choose-plan-wizard-view.controller';
import template from './choose-plan-wizard-view.component.html';

export const ChoosePlanWizardViewComponent = {
	controller: ChoosePlanWizardViewController,
	require: {
		wizardController: '^wizard'
	},
	template
} as IComponentOptions;
